export const getUsedTEF = (state) =>
  state.usedTEF;
